import { computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SmartbookSidebarService {
  private router = inject(Router);

  private _isOpen = signal(false);
  public isOpen = computed(() => this._isOpen());

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.setSidebar(false);
      }
    });
  }

  public setSidebar(value: boolean): void {
    this._isOpen.set(value);
  }
}
